import { Box } from '@mui/material';
import { DropDown, ChipInput, ChipInputTagErrors } from '@qrios/frontend-library';

import DateRangePicker from '../../../../../../common/fields/date-range-picker';
import { FiltersFormValues } from '../../../../../../common/reports/interfaces';
import {
  convertQueryTypeToRedableFormat,
  convertRedableFormatToQueryType
} from '../../../../../../common/table/utils/operationTypeFormatters';
import { BILLING_STATUSES, CUSTOMER_VALIDATION_QUERY_TYPES, FILTERS } from '../../../../../../common/filters/constants';

import locales from '../locales';
import { CustomerValidationReportCreateForm } from '../interfaces';

interface Props extends FiltersFormValues<CustomerValidationReportCreateForm> {}

const FiltersForm = ({ errors, touched, values, handleChange, handleBlur }: Props) => {
  const handleQueryTypesChange = (field: string, value: string[]) => {
    const convertedValue = value.map(queryTypeString => convertRedableFormatToQueryType(queryTypeString));
    handleChange(field, convertedValue);
  };

  return (
    <Box mt={2} mb={6}>
      <DateRangePicker
        from={{ name: FILTERS.FROM, value: values.from, error: errors.from, touched: touched.from }}
        to={{ name: FILTERS.TO, value: values.to, error: errors.to, touched: touched.to }}
        handleFromChange={value => handleChange(FILTERS.FROM, value)}
        handleToChange={value => handleChange(FILTERS.TO, value)}
        handleBlur={handleBlur}
      />
      <DropDown
        label={locales.filtersForm.queryType.label}
        value={values.queryTypes.map(queryType => convertQueryTypeToRedableFormat(queryType))}
        options={CUSTOMER_VALIDATION_QUERY_TYPES.map(queryType => convertQueryTypeToRedableFormat(queryType))}
        name="queryTypes"
        handleChange={handleQueryTypesChange}
        handleBlur={handleBlur}
        multiple={true}
        placeholder={locales.filtersForm.queryType.placeholder}
      />
      <DropDown
        label={locales.filtersForm.statuses.label}
        placeholder={locales.filtersForm.statuses.placeholder}
        value={values.statuses}
        options={BILLING_STATUSES}
        name="statuses"
        handleChange={handleChange}
        handleBlur={handleBlur}
        multiple={true}
      />
      <ChipInput
        error={errors.operationIds?.[(errors.operationIds ?? []).length - 1]}
        label={locales.filtersForm.operationIds.label}
        value={values.operationIds}
        name="operationIds"
        handleChange={handleChange}
        handleBlur={handleBlur}
        placeholder={locales.filtersForm.operationIds.placeholder}
        tagErrors={errors.operationIds as ChipInputTagErrors}
      />
    </Box>
  );
};

export default FiltersForm;
